import Vue from 'vue'
import SecureHref from 'directives/secure-v-href'

Vue.directive('secure-v-href', SecureHref)
